// =====================================================
// 📁 PendingQuotationsPanel.tsx
// =====================================================

import { useEffect } from 'react';

import { FileText } from 'lucide-react';

import { useQuotation } from '../../../../../hooks/sale/useQuotation';

import PendingQuotationsList from './PendingQuotationsList';
import PendingQuotationsEmpty from './PendingQuotationsEmpty';

interface Props {
  navigateOnContinue?: boolean;
}

const PendingQuotationsPanel: React.FC<Props> = ({
  navigateOnContinue = false,
}) => {
  // =====================================================
  // 🔹 Hooks
  // =====================================================

  const { pendingQuotations, getPendingQuotations } = useQuotation();

  // =====================================================
  // 🔹 Effects
  // =====================================================

  useEffect(() => {
    getPendingQuotations();
  }, []);

  // =====================================================
  // 🔹 States
  // =====================================================

  const hasQuotations = pendingQuotations.length > 0;

  // =====================================================
  // 🎨 Render
  // =====================================================

  return (
    <div className="flex flex-col gap-5">
      {/* ===================================================== */}
      {/* Header */}
      {/* ===================================================== */}

      <div
        className="
        flex
        flex-col
        gap-4

        sm:flex-row
        sm:items-center
        sm:justify-between
      "
      >
        {/* Left */}

        <div
          className="
          flex
          min-w-0
          items-start
          gap-3

          sm:items-center
        "
        >
          <div
            className="
            flex
            h-11
            w-11
            shrink-0
            items-center
            justify-center

            rounded-xl

            border
            border-primary/10

            bg-primary/5

            text-primary
          "
          >
            <FileText size={20} />
          </div>

          <div className="min-w-0">
            <h3
              className="
              break-words

              text-base
              font-semibold

              text-black

              dark:text-white
            "
            >
              Cotizaciones Pendientes
            </h3>

            <p
              className="
              mt-1

              text-sm

              text-body
            "
            >
              Continúa cotizaciones pausadas.
            </p>
          </div>
        </div>

        {/* Counter */}

        <div
          className="
          bg-gray-1

          inline-flex
          h-10

          min-w-[48px]
          items-center

          justify-center

          rounded-xl
          border

          border-stroke

          px-3

          text-sm
          font-semibold

          text-black

          transition-colors
          duration-200

          dark:border-strokedark
          dark:bg-meta-4
          dark:text-white
        "
        >
          {pendingQuotations.length}
        </div>
      </div>

      {/* ===================================================== */}
      {/* Content */}
      {/* ===================================================== */}

      {hasQuotations ? (
        <PendingQuotationsList
          quotations={pendingQuotations}
          navigateOnContinue={navigateOnContinue}
        />
      ) : (
        <PendingQuotationsEmpty />
      )}
    </div>
  );
};

export default PendingQuotationsPanel;
